module.exports = "<div class=\"container-fluid s-main\">\n  <div class=\"row s-main__row\">\n    <app-side-bar></app-side-bar>\n    <div class=\"main-panel\">\n      <div class=\"container-fluid\">\n        <router-outlet></router-outlet>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/base/base.component.html
// module id = ./src/app/layout/base/base.component.html
// module chunks = main